import React from 'react'
import { Route, IndexRoute } from 'react-router'

import { isAuthorized } from 'utils/Auth'
import { getMe } from 'reduxpath/ducks/Auth'

import NotFound from 'units/NotFound'

/** Layouts */
import Guest from 'populators/Layouts/Guest'
import Member from 'populators/Layouts/Member'

/** Route */
import Dashboard from './Dashboard'
import Signup from './Signup'
import Signin from './Signin'
import Signout from './Signout'
import Thankyou from './Thankyou'
import GuestNotFound from './GuestNotFound'
import Impersonate from './Impersonate'

/** Organisations */
import AdminCreatedUser from './AdminCreatedUser'
import Client from './Client'
import Creator from './Creator'
import FinanceProfile from './FinanceProfile'
import Profile from './Profile'
import ProfileBankInformation from './ProfileBankInformation'
import Product from './Product'
import ProductBrandNew from './ProductBrandNew'
import PendingProduct from './PendingProduct'
import ZotapayInvoices from './ZotapayInvoices'
import Project from './Project'
import ProjectList from './ProjectList'
import TaskList from './TaskList'
import PaymentConfirmation from './PaymentConfirmation'
import User from './User'
import CategoryManagement from './CategoryManagement'
import TopicsManagement from './TopicsManagement'
import OccupationsManagement from './OccupationsManagement'

/** Settings page */
import Bank from './Bank'
import CountryTax from './CountryTax'
import Format from './Format'
import ProductLanguage from './ProductLanguage'
import ProductType from './ProductType'
import Service from './Service'
import Standard from './Standard'
import Tag from './Tag'
import Tax from './Tax'
import Email from './Email'

const Basics = (store) => {
  const GuestRoute = () => (
    <Route path="/">
      <Route component={Guest.components.Layout}>
        {Signin()}
        {Signup()}
        {Thankyou()}
        {GuestNotFound()}
      </Route>
    </Route>
  )

  const MemberRoute = () => (
    <Route path="/" name="Home">
      <Route component={Member.components.Layout}>
        <IndexRoute component={Dashboard.components.Home} name="Dashboard" />

        {/* Admin Created User routes => /admin-created-user */}
        {AdminCreatedUser(store)}

        {/* Bank routes => /banks */}
        {Bank(store)}

        {/* CountryTax routes => /country_taxes */}
        {CountryTax(store)}

        {/* Creator routes => /creators */}
        {Creator(store)}
        {/* Client routes => /clients */}
        {Client(store)}

        {/* User routes => /users */}
        {User(store)}

        {/* Profile routes => /profiles */}
        {Profile(store)}

        {/* FinanceProfile routes => /finance_profiles */}
        {FinanceProfile(store)}

        {/* ProfileBankInformation routes => /profiles_bank_information */}
        {ProfileBankInformation(store)}

        {/* Product routes => /products */}
        {Product(store)}

        {/* Product routes => /products-brand-new */}
        {ProductBrandNew(store)}

        {/* Product routes => /pending-products */}
        {PendingProduct(store)}

        {/* PaymentRecieved routes => /payment-recieved */}
        {ZotapayInvoices(store)}

        {/* Project routes => /projects */}
        {Project(store)}

        {/* ProjectList routes => /projectslist */}
        {ProjectList(store)}

        {/* PaymentConfirmation routes => /payment_confirmation */}
        {PaymentConfirmation(store)}

        {/* Format routes => /formats */}
        {Format(store)}

        {/* Content Type routes => /content_types */}
        {ProductLanguage(store)}

        {/* Product Type routes => /product_types */}
        {ProductType(store)}

        {/* Service routes => /services */}
        {Service(store)}

        {/* Standard routes => /standards */}
        {Standard(store)}

        {/* Tag routes => /tags */}
        {Tag(store)}

        {/* TaskList routes => /tasklists */}
        {TaskList(store)}

        {/* Tag routes => /tax */}
        {Tax(store)}

        {/* Email routes => /emails */}
        {Email(store)}

        {/* Cateogry Management routes => /category-management */}
        {CategoryManagement(store)}

        {/* Topics Management routes => /topics-management */}
        {TopicsManagement(store)}

        {/* Occupations Management routes => /occupations-management */}
        {OccupationsManagement(store)}

        {/* Impersonate routes => /impersonate */}
        {Impersonate(store)}

        {Signout(store)}
      </Route>
    </Route>
  )

  const MainRoutes = () => (
    isAuthorized()
      ? MemberRoute()
      : GuestRoute()
  )

  return MainRoutes()
}

export default (store, err) => {
  if (isAuthorized() && !err) {
    const token = JSON.parse(isAuthorized())
    store.dispatch(getMe(token))
  }

  return (
    <Route>
      {Basics(store)}
      <Route path="*" component={NotFound} />
    </Route>
  )
}
